import { useState } from 'react';
import GetIcon from '../../utils/Icon';

const CollapsibleSection = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="col-12">
      <div
        className="py-2 d-flex justify-content-between align-items-center"
        style={{ borderBottom: "1px solid #D9D9D9", cursor: "pointer" }}
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="firstcolor m-0">{title}</p>
        <span
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.3s",
          }}
        >
          <GetIcon iconName="MdKeyboardArrowDown" size={22} />
        </span>
      </div>
      {isOpen && <div className="mt-2">{children}</div>}
    </div>
  );
};


export default CollapsibleSection;